import { render, staticRenderFns } from "./Continent.vue?vue&type=template&id=b6dd0768"
import script from "./Continent.vue?vue&type=script&lang=ts"
export * from "./Continent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports